import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StarMedalIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M22.54 6.405a3.37 3.37 0 00-1.15-2.11l-3.9-3.34h-.01l-.05-.05a.79.79 0 00-.32-.17c-.09-.03-.19-.05-.29-.06H7.2c-.11 0-.22.03-.33.07-.02 0-.04.01-.05.02-.09.04-.17.09-.24.15l-3.97 3.38a3.37 3.37 0 00-1.15 2.11c-.11.82.08 1.65.54 2.34l3.42 5.13c-.28.77-.44 1.59-.44 2.43 0 1.88.73 3.64 2.06 4.96a6.968 6.968 0 004.96 2.06c1.87 0 3.66-.75 4.96-2.06a6.968 6.968 0 002.06-4.96c0-.85-.16-1.67-.44-2.44L22 8.735c.46-.69.65-1.52.54-2.34v.01zm-13.09-.97l-.86-2.78h6.83l-.86 2.78H9.45zm4.48 2l-.62 1.99c-.43-.08-.87-.13-1.31-.13-.44 0-.89.04-1.31.13l-.62-1.98h3.86v-.01zm-10.27.21c-.19-.28-.27-.62-.22-.96.05-.34.21-.64.47-.86l2.81-2.41 2.07 6.66c-.64.33-1.23.76-1.76 1.28-.18.18-.36.38-.52.58l-2.86-4.29h.01zm11.89 12.23a5.02 5.02 0 01-7.1 0 4.985 4.985 0 01-1.47-3.55c0-.68.14-1.34.4-1.95.02-.03.03-.06.05-.09a4.985 4.985 0 014.58-2.98c1.34 0 2.62.54 3.55 1.47.43.43.75.92 1 1.46.03.05.05.11.08.16.25.61.39 1.26.39 1.94 0 1.34-.52 2.6-1.47 3.55l-.01-.01zm4.79-12.23l-2.86 4.29a9.2 9.2 0 00-.51-.58c-.52-.52-1.12-.95-1.77-1.28l1-3.23.03-.1 1.04-3.34 2.81 2.41c.26.22.43.53.47.86.05.34-.03.68-.22.96l.01.01z"
                        }),
                        _jsx("path", {
                            d: "M15.68 14.705c-.18-.15-.4-.25-.63-.28l-1.32-.2-.6-1.2v-.02c-.12-.21-.28-.38-.49-.5-.2-.12-.43-.18-.66-.17-.24 0-.46.08-.65.19-.2.13-.36.31-.46.51l-.59 1.2-1.34.2a1.269 1.269 0 00-1 .85 1.26 1.26 0 00.32 1.3l.95.91-.22 1.3c-.05.24-.03.49.06.72.07.16.16.31.3.45.13.13.29.22.45.27.14.05.28.07.42.07h.11c.19-.01.36-.07.5-.15l1.17-.62 1.14.6c.21.12.45.19.71.17.24-.01.47-.09.67-.24.2-.14.34-.34.43-.55.09-.23.11-.49.07-.66l-.2-1.39.92-.88c.16-.16.28-.36.35-.6.06-.23.05-.47-.02-.68-.07-.23-.21-.43-.39-.59v-.01zm-2.58 1.62c-.08.08-.14.16-.19.26-.09.18-.14.38-.14.58 0 .12.02.24.05.36l.02.17-.29-.15c-.17-.08-.36-.12-.55-.12-.19 0-.38.04-.59.14l-.2.1.03-.18c.04-.17.04-.35 0-.52-.04-.2-.13-.39-.26-.55-.03-.03-.05-.06-.08-.09l-.16-.15.15-.02c.22-.02.44-.1.6-.22.18-.13.33-.31.4-.47l.11-.21.08.15c.09.21.23.38.4.51.18.13.4.22.56.23l.21.03-.16.16.01-.01z"
                        })
                    ]
                })
            })
        ]
    });
};
StarMedalIcon.isCarinaIcon = true;
export default StarMedalIcon;
